import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=3120012b&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/productList.scss?vue&type=style&index=0&id=3120012b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120012b",
  null
  
)

export default component.exports